import React, { useState, useEffect, useCallback } from 'react'
import { Box, Typography, Paper } from '@mui/material'
import ElementFields from './ElementFields'

export interface ElementInspectorProps {
  element: any
  elementIndex: number
  segmentIndex: number
  loopIndex: number
  onChange: (data: any) => void
  readonly?: boolean
}

const ElementInspector = React.memo<ElementInspectorProps>(
  ({ element, elementIndex, segmentIndex, loopIndex, onChange, readonly = false }) => {
    const [localElement, setLocalElement] = useState(element)

    useEffect(() => {
      setLocalElement(element)
    }, [element])

    const handleFieldChange = useCallback(
      (field: string, value: any) => {
        const updatedElement = {
          ...localElement,
          [field]: value,
        }
        setLocalElement(updatedElement)
        onChange(updatedElement)
      },
      [localElement, onChange]
    )

    if (!localElement) {
      return (
        <Box sx={{ p: 2 }}>
          <Typography variant="body2" color="text.secondary">
            No element data available
          </Typography>
        </Box>
      )
    }

    return (
      <Box sx={{ p: 2 }}>
        {/* Element Properties */}
        <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
          <Typography variant="h6" gutterBottom fontWeight={'bold'} pb={2}>
            Element Properties
          </Typography>
          <ElementFields
            element={localElement}
            elementIndex={0}
            readonly={readonly}
            onFieldChange={(index, field, value) => handleFieldChange(field, value)}
            showDescription={true}
            showNotes={true}
            showCodes={true}
            showDefault={true}
          />
        </Paper>
      </Box>
    )
  }
)

ElementInspector.displayName = 'ElementInspector'

export default ElementInspector
